module.exports = function() {
  return new Worker(__webpack_public_path__ + "f6d65c4df9b7807d0dcd.worker.js");
};